module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-G-Landing-page.5a2ec118.webp";